import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CanActivate } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.auth.isAuthenticated()) {
      console.log(this.auth);
      // if (this.auth.isAdmin()) {
      return true;
      // } else {
      //   this.router.navigate(['']);
      //   return false;
      // }
    } else {
      return false;
      // localStorage.setItem('redirect_url', state.url);
      // this.auth.login();
      // this.router.navigate(['']);
      // return false;
    }
  }
}



// WEBPACK FOOTER //
// /ng-app/src/app/shared/auth/auth.guard.ts